import { IPageNoPresentable, instanceOfIPageNoPresentable } from "./IPageNoPresentable";

export interface IPageNoEditable extends IPageNoPresentable {
  setCurrentPageNo(pageNo: number): void;
}

export function instanceOfIPageNoEditable(instance: any): instance is IPageNoPresentable {
  return instance
    && (instance.setCurrentPageNo !== undefined)
    && instanceOfIPageNoPresentable(instance);
}
